var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"employee-section",attrs:{"id":"pending-orders"}},[_c('horizontal-hero'),_c('div',{staticClass:"pending-order-wrapper"},[_c('h1',[_vm._v("Pending Orders")]),_vm._l((this.$store.state.pendingOrders),function(order){return _c('order-item',{key:order.id,attrs:{"order":order}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }